import { useState, useRef, useEffect } from "react";
import { FiEdit3 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../state/store";
import { updateCaselet } from "../pages/caselet/caseletSlice";
import { handleUpdateCaseletClick } from "../pages/thoughts/chat/ChatCardButton";
import { newChallenge } from "../pages/caselet/challenges/DecisionPoint";
import { successToast } from "../utils/common";
import Alert from "./Alert";

interface CardProps {
    title: string;
    caseletId?: string;
    content?: string;
    decisionPointTitle?: string;
    published: boolean;
    setActiveTabToChallenge?: (data: number) => void;
}

const Card = ({ title,caseletId, content: initialContent, decisionPointTitle, setActiveTabToChallenge, published }: CardProps) => {
    const unsavedChallenge=JSON.stringify(caseletId)?.concat("-unsavedChallenge-")?.concat(JSON.stringify(title));
    const [isEditingFalse, setIsEditingFalse] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const caseletData = useSelector((state: RootState) => state.caselet);
    const dispatch = useDispatch<AppDispatch>();
    const [content, setContent] = useState("");
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const contentString = Array.isArray(initialContent)
        ? initialContent.join("")
        : typeof initialContent === "object"
        ? JSON.stringify(initialContent)
        : initialContent;
    const contentIsEmpty = !initialContent || (Array.isArray(initialContent) && initialContent.length === 0);


    useEffect(() => {
        if (isEditingFalse && textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.minHeight = `${textareaRef.current.scrollHeight}px`;
            textareaRef.current.focus();
        }
        var unSavedData=localStorage.getItem(unsavedChallenge);
        if(unSavedData!==null){
            setContent(unSavedData);
        }
    }, [isEditingFalse]);

    useEffect(() => {
        if (isEditingFalse) {
            setIsEditingFalse(false);
        }
    }, [decisionPointTitle]);

    const handleEdit = () => {
        setIsEditingFalse(false);
    };

    const handleContentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setContent(event.target.value);
        localStorage.setItem(unsavedChallenge,event.target.value)
    };

    const handleSave = async (event: React.MouseEvent) => {
        let optionFlag = false;
        event.stopPropagation();
        if (typeof content === "string") {
            if (decisionPointTitle) {
                newChallenge.title = decisionPointTitle;
            }
            newChallenge.challenge = content;
        }

        let updatedCaselet = JSON.parse(JSON.stringify(caseletData));

        for (let i = 0; i < updatedCaselet.challenges.length; i++) {
            if (updatedCaselet.challenges[i].title === decisionPointTitle) {
                updatedCaselet.challenges.splice(i, 1, newChallenge);
            }
        }

        const result = await handleUpdateCaseletClick(updatedCaselet);
        dispatch(updateCaselet(result.caselet));
        localStorage.removeItem(`${caseletId}isEmptyDecisionPointExist`);
        for (var key of Object.keys(localStorage)) {
            if (key.includes("Decision Point")) {
                optionFlag = true;
                break;
            }
        }
        if(!optionFlag)
            localStorage.removeItem(`${caseletId}activeTab`);
        setIsEditingFalse(true);
        setContent(contentString || "");
        successToast("Saved Successfully");
        localStorage.removeItem(unsavedChallenge);
    };

    const handleCancel = (event: React.MouseEvent) => {
        event.stopPropagation();
        setContent(contentString || "");
        setIsEditingFalse(true);
         localStorage.removeItem(unsavedChallenge);
    };

    const handleDiscardChanges = () => {
        setIsEditingFalse(false);
        setShowAlert(false);
        const updatedChallenges = [...caseletData.challenges];
        updatedChallenges.pop();
        dispatch(updateCaselet({ ...caseletData, challenges: updatedChallenges }));
        if (typeof setActiveTabToChallenge == "function") {
            setActiveTabToChallenge(updatedChallenges.length - 1);
        }
    };

    const handleStayEditing = () => {
        setShowAlert(false);
    };

    return (
        <div className="card-component bg-white mt-4 text-black p-4 rounded-lg transition-transform w-full sm:w-8/10 relative shadow-lg">
            <h2 className="font-title">{title}</h2>
            <div className="card-content min-h-fit hyphens-auto" style={{ maxWidth: "99%", overflowWrap: "break-word" }}>
                {contentIsEmpty && !isEditingFalse && !published ? (
                    <textarea
                        className="w-11/12 p-2 border-2 border-solid"
                        value={content}
                        onChange={handleContentChange}
                        onFocus={e => {
                            e.target.setSelectionRange(e.target.value.length, e.target.value.length);
                        }}
                        style={{ resize: "none" }}
                        ref={textareaRef}
                        autoFocus
                    />
                ) : (
                    contentString
                )}
            </div>
            <div>
                {contentIsEmpty && !isEditingFalse && !published ? (
                    <>
                        <div className="font-hover-save font-top-position">{content?.trim().length ? <button onClick={handleSave}>Save</button> : ""}</div>
                        <div className="font-hover-cancel font-bottom-position">
                            <button onClick={handleCancel}>Cancel</button>
                        </div>
                    </>
                ) : (
                    <div className="font-hover-edit font-top-position flex">
                        {contentIsEmpty && !published ? <FiEdit3 className="mr-3 cursor-pointer" onClick={handleEdit} /> : ""}
                    </div>
                )}
            </div>

            <Alert showAlert={showAlert} handleStayEditing={handleStayEditing} handleDiscardChanges={handleDiscardChanges} />
        </div>
    );
};

export default Card;
